import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

// Holds all the current experiments running in Blossom. Update this as
// needed and clean up as needed
export enum Experiment {
  Flex_HTG_Blossom_Map_Filtering = "Flex_HTG_Blossom_Map_Filtering",
  Flex_HTG_Blossom_Map_To_HSR = "Flex_HTG_Blossom_Map_To_HSR",
  LOB_intent_search_button_text_hotels_pwa = "LOB_intent_search_button_text_hotels_pwa",
  PWA_HLP_DEST_RECS = "PWA_HLP_DEST_RECS",
  Blossom_Date_Intervals_Mobile_HTG = "Blossom_Date_Intervals_Mobile_HTG",
  Blossom_Hotel_Image_Carousel = "Blossom_Hotel_Image_Carousel",
  Blossom_Recently_Viewed_Hotels = "Blossom_Recently_Viewed_Hotels",
  Bex_Bundle_AA_property_types_during_search = "Bex_Bundle_AA_property_types_during_search",
  Flex_check_prices_version_3 = "flex_check_prices_version_3",
  Flex_Blossom_Qualtrics = "Flex_Blossom_Qualtrics",
  BEX_See_All_Properties_Link_Desktop = "BEX_See_All_Properties_Link_Desktop",
  HTG_Add_Top_POI_Pins = "HTG_Add_Top_POI_Pins",
  PWA_ESS_Feedback_Loop_Enable = "PWA_ESS_Feedback_Loop_Enable",
  Compass_Wizard_DX_Pages = "Compass_Wizard_DX_Pages",
  EG_UIDE_SDK_SF_test = "EG_UIDE_SDK_SF_test",
  BEX_HTG_Affinity_Filters_See_More_Link = "BEX_HTG_Affinity_Filters_See_More_Link",
  Flex_HTG_Blossom_POSa_Redirect_Banner = "Flex_HTG_Blossom_POSa_Redirect_Banner"
}

/**
 * Return bucket number of experiment.
 * @param {ExtendedContextStore} context - Store where the experiments array live
 * @param {string} experimentName - Experiment name used (check out link)
 * @returns {number} - Experiment Bucket
 */

export const getExperimentBucket = (
  context: ExtendedContextStore,
  experimentName: Experiment
): number =>
  context &&
  context.experimentContext &&
  context.experimentContext.experiments &&
  context.experimentContext.experiments[experimentName];

/**
 * Checks if an experiment is in a given variant.
 * {@link https://tnl.prod.expedia.com}
 * @param {ExtendedContextStore} context - Store where the experiments array live
 * @param {string} experimentName - Experiment name used (check out link)
 * @param {number} value - Defaults to 1. Value that we are checking the experiment against
 * @returns {boolean} - True when the context contains an experiment string that matches a given numeric value
 */
export const isVariantEnabled = (
  context: ExtendedContextStore,
  experimentName: Experiment,
  value: number = 1
): boolean => getExperimentBucket(context, experimentName) === value;
